import type { GetProjectById200UserInfoBasicInfo } from './getProjectById200UserInfoBasicInfo';
import type { GetProjectById200UserInfoSocial } from './getProjectById200UserInfoSocial';

/**
 * 간략한 사용자 정보
 */
export type GetProjectById200UserInfo = {
  /** 사용자 기본 정보 */
  basicInfo: GetProjectById200UserInfoBasicInfo;
  /** 소셜 관계 정보 */
  social?: GetProjectById200UserInfoSocial;
};
